import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, EDIT, YES, ACTIVE } from "const"
import {
    StoreType,
    moduleIds,
    setCcRequirementBaseRoute,
} from "client/store"
import {
    projectsRoute,
    projectBaseRoute,
    projectCcRequirementsRoute,
} from "client/parts/routes"
import { Switch, Route } from "client/components"

import AccessDenied from "client/parts/accessDenied"

import RequirementList from "./requirementList"
import RequirementView from "./requirementView"
import RequirementEdit from "./requirementEdit"

const CcRequirement = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const packageSettings = useSelector((state: StoreType) => state.system.packageSettings)
    const moduleList = useSelector((state: StoreType) => state.module.moduleList)
    const dispatch = useDispatch()

    const { ccModuleAccess } = packageSettings
    const moduleAccess = ccModuleAccess === YES && moduleList[moduleIds.cc].status === ACTIVE

    const baseRouteMask = `${projectBaseRoute}${projectCcRequirementsRoute}`
    const baseRoute = `${projectsRoute}/${VIEW}/${project.id}${projectCcRequirementsRoute}`

    useEffect(() => {
        dispatch(setCcRequirementBaseRoute(baseRoute))
    }, [])

    if (!moduleAccess) return <AccessDenied />
    return (
        <Switch>
            <Route
                path={`${baseRouteMask}/${VIEW}/:requirementId`}
                component={RequirementView}
            />
            <Route
                path={`${baseRouteMask}/${EDIT}/:requirementId`}
                component={RequirementEdit}
            />
            <Route
                path={baseRouteMask}
                component={RequirementList}
            />
        </Switch>
    )
}
export default CcRequirement
